import React from "react";
import Layout from "../Layout";
import Form from "./form";
import useApi from "Hooks/Admin/useApi";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";

function Type(props) {
  const { request } = useApi();
  const stateError = useError();
  const messages = message();

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - メディア仕分け登録";
  }, []);

  const handleSubmit = (type) => {
    let data = {
      label: type.label,
      sources: (type.sources).split("\n"),
      color: type.color
    };

    request({
      method: "POST",
      url: `admin/media/types`,
      data: data,
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/admin/media/types?success=create");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
        />
      }
    />
  );
}
export default withRouter(Type);
